var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'WatchDashboard', params: { user_uid: _vm.user_uid, watch_id: _vm.watch.id } }}},[_c('div',{staticClass:"bullet"}),_vm._v(" "),_c('avatar-picture-virtual-watch',{attrs:{"watch_id":_vm.watch.id}}),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.watch.profile_name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-190b96a1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/watches/UserWatchesPatientsGridWatch.vue
// module id = null
// module chunks = 